import {NEW_PROJECT} from "../actions/ProjectAction";
import {UPLOAD_FAILURE, UPLOAD_PROGRESS, UPLOAD_SUCCESS} from "../actions/FileUploadAction"

const newProjectReducer = (state = {filesUploading: []}, action) => {

    switch (action.type) {

        case NEW_PROJECT:

            const newUploads = action.newProject.projectFiles.map((file) => ({file: file, progress: 0}));
            return {
                ...state,
                filesUploading: [...state.filesUploading, ...newUploads]
            };
        case UPLOAD_PROGRESS: {

            return {
                ...state,
                filesUploading: state.filesUploading.map(upload => upload.file === action.meta.file ? {...upload, progress: action.payload} : upload)
            }
        }
        case  UPLOAD_SUCCESS: {

            return {
                ...state,
                filesUploading: state.filesUploading.filter(upload => upload.file !== action.meta.file)
            }
        }
        case  UPLOAD_FAILURE: {

            return {...state}
        }
        default:
            return state;
    }
};

export default newProjectReducer;